var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from 'path-shared/models/filter-data';
var InfraccioFilter = /** @class */ (function (_super) {
    __extends(InfraccioFilter, _super);
    function InfraccioFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.id = null;
        _this.legislacio = '';
        _this.article = '';
        _this.apartat = '';
        _this.opcio = '';
        _this.gravetat = '';
        _this.descCurta = '';
        _this.import = null;
        _this.fins = '';
        _this.punts = '';
        _this.obsoleta = null;
        _this.inici = null;
        _this.final = null;
        _this.numFotosPda = null;
        _this.labels['id'] = _this.i18n('Id');
        _this.labels['legislacio'] = _this.i18n('Legislació');
        _this.labels['article'] = _this.i18n('Article');
        _this.labels['apartat'] = _this.i18n('Apartat');
        _this.labels['opcio'] = _this.i18n('Opció');
        _this.labels['gravetat'] = _this.i18n('Gravetat');
        _this.labels['descCurta'] = _this.i18n('Descripció curta');
        _this.labels['import'] = _this.i18n('Import');
        _this.labels['fins'] = _this.i18n('Fins');
        _this.labels['punts'] = _this.i18n('Punts');
        _this.labels['obsoleta'] = _this.i18n('Obsoleta');
        _this.labels['inici'] = _this.i18n('Inici');
        _this.labels['final'] = _this.i18n('Final');
        _this.labels['numFotosPda'] = _this.i18n('Número fotos PDA');
        return _this;
    }
    return InfraccioFilter;
}(FilterData));
export { InfraccioFilter };
